module.exports = require("./a");


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/b.js
 ** module id = 8
 ** module chunks = 5
 **/